import component from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-information/lni-child-labor-complaint-information.component.vue';
import module from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-information/lni-child-labor-complaint-information.module.js';

export default {
    component,
    module,
};